import { clampScore, formatScore, scoreTier } from './scoreUtils'
import { normalizeQuestStatus } from './questTypes'

export const TIER_LABEL = {
  low: '铜',
  mid: '银',
  high: '金',
  perfect: '荣耀',
  none: '未评级',
}

export function itemStatus(item) {
  return normalizeQuestStatus(
    item?.progress?.status,
    item?.assignmentStatus || item?.progress?.assignmentStatus,
  )
}

export function summarizeSection(section, stageIndex) {
  const items = section?.items || []
  let done = 0
  let sum = 0
  let scored = 0
  items.forEach((item) => {
    if (itemStatus(item) !== 'evaluated') return
    done += 1
    const score = clampScore(item?.evaluationSummary?.score)
    if (score == null) return
    sum += score
    scored += 1
  })
  const avg = scored ? sum / scored : null
  const earned = items.length > 0 && done === items.length
  return {
    stageIndex,
    stageKey: `${section?.no ?? 'x'}-${stageIndex}`,
    title: section?.title || '',
    done,
    total: items.length,
    remaining: Math.max(0, items.length - done),
    earned,
    avg,
    tier: earned ? scoreTier(avg) : 'none',
    avgText: avg == null ? '' : formatScore(avg),
  }
}

export function badgeStorageKey(courseId) {
  return `ybg.questMap.badges.${courseId || 'none'}`
}
